import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { Form } from "react-bootstrap";
import FeeSystemMenu from "./FeeSystemMenu";

function AdvanceAmountReport(props) {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [onlyWithBalance, setOnlyWithBalance] = useState(true);
  const [totals, setTotals] = useState({ TotalAdvanceAmount: 0, TotalAdjustmentAmount: 0, TotalRemainingAdvance: 0 });

  const loadReport = (showOnlyWithBalance = null) => {
    const useOnlyWithBalance = showOnlyWithBalance !== null ? showOnlyWithBalance : onlyWithBalance;
    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "ADLedger/GetAdvanceAmountReport",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey: AccessKey,
        UserID: UserID,
        MemberType: MemberType || "Admin",
        LoadAll: !useOnlyWithBalance,
      },
    })
      .then((response) => {
        if (response.data.status_code == 1) {
          setList(response.data.ListofRecords || []);
          setTotals({
            TotalAdvanceAmount: response.data.TotalAdvanceAmount || 0,
            TotalAdjustmentAmount: response.data.TotalAdjustmentAmount || 0,
            TotalRemainingAdvance: response.data.TotalRemainingAdvance || 0,
          });
        } else {
          setList([]);
          toast.error(response.data.status_message || "Failed to load report.", { position: toast.POSITION.TOP_RIGHT });
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Network Error.", { position: toast.POSITION.TOP_RIGHT });
      });
  };

  useEffect(() => {
    document.title = "Advance Amount Report";
    loadReport();
  }, []);

  return (
    <>
      <FeeSystemMenu />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item"><Link to="/">Dashboard</Link></li>
                  <li className="breadcrumb-item"><Link to="/FeeSystem/FeeSystemDashboard">Fee System</Link></li>
                  <li className="breadcrumb-item active" aria-current="page">Advance Amount Report</li>
                </ol>
              </nav>
              <div className="page-title">Advance Amount Report</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions">
                <Form.Check
                  type="checkbox"
                  label="Only with balance"
                  checked={onlyWithBalance}
                  onChange={(e) => {
                    const v = e.target.checked;
                    setOnlyWithBalance(v);
                    loadReport(v);
                  }}
                />
                <button type="button" className="button button-white button-icon ms-2" onClick={loadReport} disabled={loading}>
                  Refresh
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-content">
        <div className="container">
          <div className="card">
            <div className="card-body">
              <div className="mb-3">
                <strong>Total Advance Received:</strong> {totals.TotalAdvanceAmount.toLocaleString()} &nbsp;|&nbsp;
                <strong>Total Adjusted:</strong> {totals.TotalAdjustmentAmount.toLocaleString()} &nbsp;|&nbsp;
                <strong>Total Remaining:</strong> {totals.TotalRemainingAdvance.toLocaleString()}
              </div>
              <table className="table table-theme table-hover">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Reg No</th>
                    <th>Student Name</th>
                    <th>Advance Amount</th>
                    <th>Adjusted</th>
                    <th>Remaining</th>
                    <th>Received Date</th>
                    <th>Last Adjustment Date</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr><td colSpan="8" className="text-center"><Spinner animation="border" /></td></tr>
                  ) : list.length === 0 ? (
                    <tr><td colSpan="8" className="text-center text-muted">No records found.</td></tr>
                  ) : (
                    list.map((item, idx) => (
                      <tr key={item.ID || idx}>
                        <td>{idx + 1}</td>
                        <td>{item.Registration_No}</td>
                        <td>{item.Student_Name}</td>
                        <td>{Number(item.AdvanceAmount).toLocaleString()}</td>
                        <td>{Number(item.AdjustmentAmount).toLocaleString()}</td>
                        <td>{Number(item.RemainingAdvance).toLocaleString()}</td>
                        <td>{item.ReceivedDate || "-"}</td>
                        <td>{item.AdjustmentDate || "-"}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdvanceAmountReport;
